import { BlockStack, Box, Button, Link, Popover, TextProps } from '@shopify/polaris';
import { useState } from 'react';
import BoldSmallText from '../BoldSmallText';
import RegularText from '../RegularText';
import { AddressInforWrapper, PopOverWrap } from './styled';

type Variant = TextProps['variant'];

const PopoverInformation = ({
  title,
  item,
  variant,
}: {
  title: string;
  item: { name: string; address: string; orderCount: number; mail: string; link: string };
  variant?: Variant;
}) => {
  const [active, setActive] = useState(false);

  const activator = (
    <Button variant="monochromePlain" onClick={() => setActive(!active)} disclosure>
      {(<BoldSmallText variant={variant}>{title}</BoldSmallText>) as unknown as string}
    </Button>
  );

  return (
    <PopOverWrap
      onClick={(e) => {
        e.stopPropagation();
        document.body.click();
      }}
    >
      <Popover active={active} activator={activator} onClose={() => setActive(!active)}>
        <Box padding={'300'}>
          <BlockStack gap={'300'}>
            <BlockStack>
              <BoldSmallText>{item?.name}</BoldSmallText>
              <AddressInforWrapper>{item?.address}</AddressInforWrapper>
              <RegularText tone="subdued">{item?.orderCount > 0 ? `${item.orderCount} orders` : 'No orders'}</RegularText>
            </BlockStack>
            <BlockStack gap={'200'}>
              <Link onClick={() => window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${item?.mail}`)}>{item?.mail}</Link>
              <Box minWidth="280px">
                <Button variant="secondary" onClick={() => window.open(item.link)} fullWidth>
                  View customer
                </Button>
              </Box>
            </BlockStack>
          </BlockStack>
        </Box>
      </Popover>
    </PopOverWrap>
  );
};

export default PopoverInformation;
